export enum AnalysisTypeEnum {
  MALARIA = 'malaria',
  MOLE_ANALYSIS = 'mole-analysis',
}

export interface IAnalysis {
  id: string
  createdAt: string
  updatedAt: string
}

export interface IAnalysisMalaria extends IAnalysis {
  infectedRbcCount: number
  uninfectedRbcCount: number
  estimatedParasitemiaPercent: number
  parasitemiaPercent?: number
  positiveBoxes?: number[][]
  negativeBoxes?: number[][]
  detectionProfile?: string | null
}

export interface IAnalysisMole extends IAnalysis {
  predictionLabel: string
  predictionConfidence: number
}
